import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

export const consorcioInitialState = {
  tipoBem: "",
  tipoPlano: "",
  finalPaymentValue: 0,
  ranges: {
    minBemValor: 0,
    maxBemValor: 0,
  },
  fetchedPlans: [
    {
      bemValor: 0,
      planoMeses: 0,
      bemCategoriaCodigo: "I",
      planosTipos: [
        {
          name: "",
          tipoPlanoID: 0,
          bemNome: "",
          grupo: "",
          bemId: 0,
          planoGrupoSituacao: 0,
          planoTaxaAdmTotal: 0,
          valorParcelaPrimeiroPagto: 0,
          valorParcela: 0,
          planoID: 0,
          planoPrimeiroPagto: false,
          planoExibeSimulacao: false,
          exibirTextoResolucao285: false,
          dataProximaAssembleia: null,
          detalhesPlano: {
            prazoGrupo: "",
            maxParticipantes: "",
            indiceCorrecao: "",
            lanceFixo: "",
            lanceLivre: "",
            percentualSeguro: 0,
          },
        },
      ],
    },
  ],
  selectedPlano: {
    PlanoIndex: 0,
    PlanoID: 0,
    BemID: 0,
    BemNome: "",
    BemCredito: 0,
    BemCreditoLabel: "",
    PlanoMeses: 0,
    PlanoValorParcela: 0,
    PlanoValorParcelaLabel: "",
    PlanoValorPagamento: 0,
    PlanoValorPagamentoLabel: "",
    LabelPlano: "",
    ImagemUrlPlano: "",
    exibirTextoResolucao285: false,
    dataAssembleia: "",
    tipoPlanoID: 0,
    valorPremioSeguro: 0,
    valorParcelaPrimeiroPagtoComSeguro: 0,
    valorParcelaComSeguro: 0,
  },
  fetchedProposta: {
    PropostaID: 0,
    PropostaToken: "",
    Contrato: "",
    LeadID: 0,
    LeadToken: "",
    formasPagamentoDisponiveis: [],
    Errors: [],
  },
  fetchedPlanDetails: {
    PlanoTaxas: "",
    TabelaDescricao: "",
    Rateio: null,
    SemAdesao: null,
    TaxaAdesao: 0,
    TaxaAdmTotal: 0,
    TaxaFundoReserva: 0,
    TaxaSeguroQuebra: 0,
    Titulo: "",
  },
  fetchedCategorias: [
    {
      categoriaID: "",
      nome: "",
      descricao: "Descrição da categoria",
      imagemUrl: "",
      produtoCategoria: "",
    },
  ],
  categoriaId: 0,
  filteredCategories: [],
};

export const useConsorcioStore = create()(
  immer(
    devtools(
      (set) => ({
        ...consorcioInitialState,
        setConsorcioStore: (value, type) => {
          set(
            (state) => {
              state[type] = value;
            },
            false,
            `setConsorcioStore - ${type}`,
          );
        },
      }),
      { enabled: true, name: "useConsorcioStore" },
    ),
  ),
);

export default useConsorcioStore;
